import './styles/index.less'
import editor from './editor'
import formDesign from './formDesign'
import formViewer from './formViewer'

import Draggable from 'vuedraggable'
const prototypes = {
}
const components = {
  editor,
  formDesign,
  formViewer,
}

const install = function (Vue) {
  if (install.installed) {
    return
  }

  Object.values(components).map(component => {
    Vue.use(component)
  })

  Object.keys(prototypes).forEach((key) => {
    Vue.prototype['$' + key] = prototypes[key];
  });

  Vue.component('l-editor', Vue.component('quill-editor'));
  Vue.component(Draggable);
}

//  全局引用可自动安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  ...components
}

export {
  components
}
